import { trans } from "@mongez/localization";
import { cartAtom, CartItem, useCartItemQuantity } from "core/cart";
import { checkoutAtom } from "core/checkout";
import {
  errorToast,
  Minus,
  Plus,
  Remove,
  successToast,
} from "~/design-system/components";

type CartItemQuantityProps = {
  item: CartItem;
};

export function CartItemQuantity({ item }: CartItemQuantityProps) {
  const {
    decrementOrRemoveItem,
    incrementQuantity,
    quantity,
    loading,
    removeItem,
  } = useCartItemQuantity(item, {
    onSuccess: (data) => {
      cartAtom.change("cart", data.cart);

      checkoutAtom.change("cart", data.cart);

      const isRemoved = !data.cart.items.some(
        (cartItem: CartItem) => cartItem.id === item.id,
      );
      
      if (isRemoved) {
        successToast(trans("cart.itemRemovedSuccess"));
      } else {
        successToast(trans("cart.quantityUpdated"));
      }
    },
    onError: (error) => {
      errorToast(error);
    },
  });

  return (
    <div className="animate-fade-in flex w-[90px] items-center gap-1 rounded-full border bg-white p-1 px-1 sm:w-[100px] sm:p-2 lg:gap-2 xl:w-[120px]">
      <button
        type="button"
        title={
          quantity === 1 ? trans("removeFromCart") : trans("decrementQuantity")
        }
        aria-label={
          quantity === 1 ? trans("removeFromCart") : trans("decrementQuantity")
        }
        className="cursor-pointer"
        onClick={quantity === 1 ? removeItem : decrementOrRemoveItem}
        disabled={loading}
      >
        {quantity === 1 ? (
          <div className="text-primary-800 px-2">
            <Remove width={15} height={15} />
          </div>
        ) : (
          <div className="px-2">
            <Minus width={15} height={15} />
          </div>
        )}
      </button>
      <div className="w-[20px] text-center text-base font-semibold transition-all sm:w-[30px] sm:text-lg lg:-mt-2 xl:w-[40px] xl:text-xl">
        {loading ? "..." : quantity}
      </div>
      <button
        type="button"
        title={trans("addToCart")}
        aria-label={trans("addToCart")}
        className="cursor-pointer px-2"
        onClick={incrementQuantity}
        disabled={loading}
      >
        <Plus width={15} height={15} />
      </button>
    </div>
  );
}
